import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function withCreds() {
  return { headers: { "Content-Type": "application/json" }, withCredentials: true };
}

export const api = {
  // Dashboard
  getDashboardSummary: () => axios.get(`${API}/dashboard/summary`, withCreds()),

  // Orders
  getOrders: (month, limit = 50, offset = 0) => {
    const params = new URLSearchParams();
    if (month) params.set("month", month);
    params.set("limit", limit);
    params.set("offset", offset);
    return axios.get(`${API}/orders?${params}`, withCreds());
  },
  createOrder: (data) => axios.post(`${API}/orders`, data, withCreds()),
  deleteOrder: (orderId) => axios.delete(`${API}/orders/${orderId}`, withCreds()),
  // resolution: "confirmed" (same purchase — stop counting it) | "dismissed" (separate purchases)
  resolveDuplicate: (orderId, resolution) =>
    axios.post(`${API}/orders/${orderId}/duplicate-resolution`, { resolution }, withCreds()),

  // Budget
  updateBudget: (monthlyBudget) => axios.put(`${API}/budget`, { monthly_budget: monthlyBudget }, withCreds()),

  // Gmail
  connectGmail: () => axios.post(`${API}/gmail/connect`, {}, withCreds()),
  disconnectGmail: () => axios.delete(`${API}/gmail/disconnect`, withCreds()),
  syncGmail: () => axios.post(`${API}/gmail/sync`, {}, withCreds()),
  getGmailStatus: () => axios.get(`${API}/gmail/status`, withCreds()),

  // Settings
  getSettings: () => axios.get(`${API}/settings`, withCreds()),
  toggleClarityLock: (enabled) => axios.put(`${API}/settings/clarity-lock`, { enabled }, withCreds()),
  updateCooldown: (minutes) => axios.put(`${API}/settings/cooldown`, { minutes }, withCreds()),

  // Billing
  createCheckout: (interval = "yearly") =>
    axios.post(`${API}/billing/create-checkout-session`, {
      origin_url: window.location.origin,
      interval,
    }, withCreds()),
  getCheckoutStatus: (sessionId) => axios.get(`${API}/billing/checkout-status/${sessionId}`, withCreds()),
  getBillingStatus: () => axios.get(`${API}/billing/status`, withCreds()),
  createPortalSession: () =>
    axios.post(`${API}/billing/create-portal-session`, {
      return_url: `${window.location.origin}/settings`,
    }, withCreds()),
  cancelFeedback: (data) => axios.post(`${API}/billing/cancel-feedback`, data, withCreds()),
  getBillingAudit: () => axios.get(`${API}/billing/audit`, withCreds()),

  // Feedback
  submitFeedback: (data) => axios.post(`${API}/feedback`, data, withCreds()),
  getMyFeedback: () => axios.get(`${API}/feedback/me`, withCreds()),

  // Onboarding
  getOnboarding: () => axios.get(`${API}/user/onboarding`, withCreds()),
  updateOnboarding: (data) => axios.patch(`${API}/user/onboarding`, data, withCreds()),

  // Extension events
  trackIntervention: (data) => axios.post(`${API}/extension/intervention-shown`, data, withCreds()),

  // Referral (savings-partner)
  getReferralLink: () => axios.get(`${API}/referral/link`, withCreds()),
  trackReferralClick: (data) => axios.post(`${API}/referral/click`, data, withCreds()),

  // Admin (internal analytics — gated to ADMIN_EMAILS server-side)
  getAdminMetrics: (windowDays = 30) => axios.get(`${API}/admin/metrics?window_days=${windowDays}`, withCreds()),

  // Config
  getPublicConfig: () => axios.get(`${API}/config/public`),

  // Export
  exportCSV: () => axios.get(`${API}/export/csv`, { ...withCreds(), responseType: "blob" }),
};
